import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import d from "../utils.js";
import R from "../helpers/buildURL.js";
import b from "./InterceptorManager.js";
import S from "./dispatchRequest.js";
import m from "./mergeConfig.js";
import C from "./buildFullPath.js";
import q from "../helpers/validator.js";
import I from "./AxiosHeaders.js";
var u = q.validators;
var k = /*#__PURE__*/function () {
  function k(t) {
    _classCallCheck(this, k);
    this.defaults = t, this.interceptors = {
      request: new b(),
      response: new b()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  return _createClass(k, [{
    key: "request",
    value: (function () {
      var _request2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
        var n, a;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this._request(t, e);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              if (_context.t0 instanceof Error) {
                Error.captureStackTrace ? Error.captureStackTrace(n = {}) : n = new Error();
                a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
                try {
                  _context.t0.stack ? a && !String(_context.t0.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (_context.t0.stack += "\n" + a) : _context.t0.stack = a;
                } catch (_unused) {}
              }
              throw _context.t0;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function request(_x, _x2) {
        return _request2.apply(this, arguments);
      }
      return request;
    }())
  }, {
    key: "_request",
    value: function _request(t, e) {
      typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = m(this.defaults, e);
      var _e = e,
        s = _e.transitional,
        n = _e.paramsSerializer,
        a = _e.headers;
      s !== void 0 && q.assertOptions(s, {
        silentJSONParsing: u.transitional(u.boolean),
        forcedJSONParsing: u.transitional(u.boolean),
        clarifyTimeoutError: u.transitional(u.boolean)
      }, !1), n != null && (d.isFunction(n) ? e.paramsSerializer = {
        serialize: n
      } : q.assertOptions(n, {
        encode: u.function,
        serialize: u.function
      }, !0)), e.method = (e.method || this.defaults.method || "get").toLowerCase();
      var f = a && d.merge(a.common, a[e.method]);
      a && d.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (r) {
        delete a[r];
      }), e.headers = I.concat(f, a);
      var h = [];
      var y = !0;
      this.interceptors.request.forEach(function (i) {
        typeof i.runWhen == "function" && i.runWhen(e) === !1 || (y = y && i.synchronous, h.unshift(i.fulfilled, i.rejected));
      });
      var p = [];
      this.interceptors.response.forEach(function (i) {
        p.push(i.fulfilled, i.rejected);
      });
      var l,
        o = 0,
        c;
      if (!y) {
        var r = [S.bind(this), void 0];
        for (r.unshift.apply(r, h), r.push.apply(r, p), c = r.length, l = Promise.resolve(e); o < c;) l = l.then(r[o++], r[o++]);
        return l;
      }
      c = h.length;
      var E = e;
      for (o = 0; o < c;) {
        var _r = h[o++],
          i = h[o++];
        try {
          E = _r(E);
        } catch (P) {
          i.call(this, P);
          break;
        }
      }
      try {
        l = S.call(this, E);
      } catch (r) {
        return Promise.reject(r);
      }
      for (o = 0, c = p.length; o < c;) l = l.then(p[o++], p[o++]);
      return l;
    }
  }, {
    key: "getUri",
    value: function getUri(t) {
      t = m(this.defaults, t);
      var e = C(t.baseURL, t.url);
      return R(e, t.params, t.paramsSerializer);
    }
  }]);
}();
d.forEach(["delete", "get", "head", "options"], function (t) {
  k.prototype[t] = function (e, s) {
    return this.request(m(s || {}, {
      method: t,
      url: e,
      data: (s || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function (t) {
  function e(s) {
    return function (a, f, h) {
      return this.request(m(h || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: f
      }));
    };
  }
  k.prototype[t] = e(), k.prototype[t + "Form"] = e(!0);
});
export { k as default };
